import * as Api from './api';
import { showError } from 'actions/actionCreators/snackbarActions';
import { sendHttpRequest, sendHttpCommandAndWaitForEvent } from 'actions/actionCreators/httpActions';
import * as eventTypes from './eventTypes';
import * as types from './actionTypes';
import { getMonthlyObligationsIsLoaded } from './selectors';

export function loadMonthlyObligations(documentId, siteId, partnerId, isAssociatedPartner) {
  return async (dispatch, getState) => {
    let { isLoaded } = getMonthlyObligationsIsLoaded(getState(), partnerId);
    if (isLoaded) {
      return;
    }

    try {
      const partnerMonthlyObligations = await dispatch(
        sendHttpRequest(Api.getPartnerMonthlyObligations(documentId, siteId, partnerId, isAssociatedPartner))
      );
      dispatch({ type: types.LOAD_PARTNER_MONTHLY_OBLIGATIONS_SUCCEEDED, payload: { partnerMonthlyObligations } });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function updateDocumentPartnerMonthlyObligations(data, isAssociatedPartner) {
  return async dispatch => {
    try {
      if (isAssociatedPartner) {
        return await dispatch(
          sendHttpCommandAndWaitForEvent(Api.updateDocumentAssociatedPartnerMonthlyObligations(data), 'RunningOfferCommand', [
            eventTypes.OFFER_PARTNER_MONTHLY_OBLIGATIONS_UPDATED
          ])
        );
      } else {
        return await dispatch(
          sendHttpCommandAndWaitForEvent(Api.updateDocumentPartnerMonthlyObligations(data), 'RunningOfferCommand', [
            eventTypes.OFFER_PARTNER_MONTHLY_OBLIGATIONS_UPDATED
          ])
        );
      }
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}
